import React from "react";
import { BaseEditorComponent } from "@handsontable/react";
import PhotoLibraryIcon from "@material-ui/icons/PhotoLibrary";
import { tesaDark } from "../../../../../../styles/colors";
import StyledTooltip from "../../../../../../components/Wrapper/StyledTooltip";

interface FileViewRendererComponentProps {
  value?: boolean;
  TD?: HTMLTableDataCellElement;
}
export class FileViewRendererComponent extends BaseEditorComponent<FileViewRendererComponentProps> {
  render(): React.ReactElement | undefined {
    const { TD, value } = this.props as FileViewRendererComponentProps;
    if (TD) {
      TD.style.textAlign = "center";
    }
    if (value) {
      return (
        <StyledTooltip title="View Picture or Document">
          <PhotoLibraryIcon
            fontSize="small"
            style={{
              cursor: "pointer",
              color: tesaDark,
              transform: "translateY(5px)",
            }}
          />
        </StyledTooltip>
      );
    }
    return <></>;
  }
}
export default FileViewRendererComponent;
